import React from 'react';
import { HeartIcon, StarIcon } from 'lucide-react';
import { Eyebrow, Section } from './Shared';
import { firstTestimonial, testimonials, type Testimonial } from '../data/pack';
function TestimonialCard({
  testimonial,
  featured = false
}: {
  testimonial: Testimonial;
  featured?: boolean;
}) {
  return <article className="paper-panel flex h-full flex-col border-l-4 border-l-brand-gold p-6 md:p-8" data-id="element-343" data-mp="3b1cir79weuhk">
      <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-344" data-mp="36z9469rxn9s2">
        {Array.from({
        length: 5
      }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-345" data-mp="31yl5r31djqnt" />)}
      </div>
      <blockquote className={`mt-4 flex-grow font-serif italic leading-relaxed text-brand-ink ${featured ? 'text-lg md:text-xl' : 'text-base'}`} data-id="element-346" data-mp="2x1bh3plt7j11">
        “{testimonial.text}”
      </blockquote>
      <div className="mt-6 flex items-center gap-3 border-t border-brand-ink/10 pt-5" data-id="element-347" data-mp="v8wsy8so9ic6">
        <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm bg-brand-jade font-title text-sm tracking-[0.06em] text-white" data-id="element-348" data-mp="qbn7t5cbfsu5">
          {testimonial.initials}
        </span>
        <span className="min-w-0" data-id="element-349" data-mp="m6cgbvme6l14">
          <span className="block font-title text-sm uppercase tracking-[0.12em] text-brand-jadeDeep" data-id="element-350" data-mp="77s9w5y70n2z">
            {testimonial.name}
          </span>
          <span className="mt-0.5 block text-xs text-brand-muted" data-id="element-351" data-mp="c7di76z967sd">{testimonial.context}</span>
        </span>
      </div>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="!py-10 md:!py-14" data-id="element-352" data-mp="14uhf0oo6zft2">
      <div className="mx-auto max-w-3xl" data-id="element-353" data-mp="14xlp22oc95rn">
        <TestimonialCard testimonial={firstTestimonial} featured data-id="element-354" data-mp="q7eiolblvd7b" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section data-id="element-355" data-mp="v44xz6fl64ro">
      <div className="mx-auto mb-10 max-w-2xl text-center" data-id="element-356" data-mp="v3msrkay4g7m">
        <Eyebrow className="flex items-center justify-center gap-2" data-id="element-357" data-mp="1iu8zn897rug1">
          <HeartIcon className="h-4 w-4" aria-hidden="true" data-id="element-358" data-mp="1nlqs17x68mpe" />
          Testimonios
        </Eyebrow>
        <h2 className="mt-3 font-title text-2xl leading-tight text-brand-jadeDeep md:text-4xl" data-id="element-359" data-mp="1xhqzntbu00w4">
          Lo que dicen quienes ya <span className="title-seal" data-id="element-360" data-mp="1sjz5strmm4pa">transformaron</span> su espacio
        </h2>
        <div className="double-rule mx-auto mt-5 w-24" aria-hidden="true" data-id="element-361" data-mp="1ogt1hro2qnlg" />
      </div>
      <div className="mx-auto grid max-w-6xl gap-6 md:grid-cols-3" data-id="element-362" data-mp="1jihsfj5lsh4a">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.id} testimonial={testimonial} data-id="element-363" data-mp="1eiv4ofs5fih8" />)}
      </div>
    </Section>;
}